export const actionTypes = {
  ADD_JOB: 'JOB_STORE__ADD_JOB',
  REMOVE_JOBS: 'JOB_STORE__REMOVE_JOBS',
};

export const addJob = (job: { jobToken: string; task: string; }) => ({
  type: actionTypes.ADD_JOB,
  job,
});

export const removeJob = (jobTokens: string[]) => ({
  type: actionTypes.REMOVE_JOBS,
  jobTokens,
});
